import { TReduxActions } from '../../types/redux';
import { ITabsState } from '../../types/tabs';
import { ETabsActionTypes } from '../../actions/tabs';

export const defaultTabs: ITabsState = {
  about: 'main',
  pikstandard: 'reliably',
  standard: 'yardPark',
  children: 'playgrounds',
  home: 'play',
};

export function tabsReducer(state: ITabsState = defaultTabs, action: TReduxActions) {
  if (action.type === ETabsActionTypes.UpdateTabs) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
}
